import { EarnedBadgesDesktop, EarnedBadgesMobile } from '@account/routes/AccountEvents/tabs';
import { useMediaQuery } from '@mui/material';

export const EarnedBadges = () => {
    //#region Hooks
    const isMdOrAbove = useMediaQuery((theme) => theme.breakpoints.up('md'));
    //#endregion

    return isMdOrAbove ? <EarnedBadgesDesktop /> : <EarnedBadgesMobile />;
};
